module.exports = __webpack_public_path__ + "fonts/Satoshi-BlackItalic.dea2134.woff2";